import Api from "./Api";
import Csrf from "./Csrf";

export default {
  async index() {
    await Csrf.getCookie();

    return Api.get("/cranes");
  },
  async machineTypes() {
    await Csrf.getCookie();

    return Api.get("/cranes/machine-types");
  },

  async update(id, form) {
    await Csrf.getCookie();

    return Api.patch("/cranes/" + id, form);
  },

  async add(form) {
    await Csrf.getCookie();

    return Api.post("/cranes", form);
  },

  async delete(id) {
    await Csrf.getCookie();

    return Api.delete("/cranes/" + id);

  },

  async show(id) {
    await Csrf.getCookie();

    return Api.get("/cranes/" + id);

  },

  async addToTask(crane_id, task_id, user_id) {
    await Csrf.getCookie();
    let re = {};
    try {
      re = await Api.post("/cranes/" + crane_id + "/add-to-task", { task_id: task_id, user_id: user_id });
    }
    catch (e) {
      console.log(e);
    }

    return re;

  },

  async removeFromTask(log_id) {
    await Csrf.getCookie();

    return Api.post("/cranes/" + log_id + "/remove-from-task", {});
  },

  async getTaskCranes(task_id) {
    await Csrf.getCookie();

    return Api.get("/cranes/" + task_id + "/get-task-cranes");
  },

  async takeKey(log_id, form) {
    await Csrf.getCookie();

    return Api.post("/cranes/" + log_id + "/take-key", form);
  },

  async returnKey(log_id, form) {
    await Csrf.getCookie();

    return Api.post("/cranes/" + log_id + "/return-key", form);
  },

  async setTaskCrane(task_id) {
    await Csrf.getCookie();

    return Api.post("/cranes/" + task_id + "/set-task-crane", {});
  }
};
